module.exports = __webpack_public_path__ + "img/DZ.90c281a6.svg";